import script from "./AdminImportQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminImportQuestions.vue?vue&type=script&setup=true&lang=js"

import "./AdminImportQuestions.vue?vue&type=style&index=0&id=7d215cf6&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d215cf6"]])

export default __exports__